module.exports = __webpack_public_path__ + "static/media/time.9992ff02.svg";